import { useMutation, useQueryClient } from '@tanstack/react-query';
import { apiClient } from '@/api/client';
import { API_SURVEYS } from '@/api/endpoints';
import { SURVEY_QUERY_KEY, SURVEYS_QUERY_KEY } from '@/api/queryKeys';
import { ErrorMessage, logRequestError } from '@/utils/errors';
import { joinPath } from '@/utils/global';

export const useStartSurvey = () => {
  const queryClient = useQueryClient();

  const { mutate: startSurvey, isPending: isStarting } = useMutation({
    mutationFn: (surveyId: string) =>
      apiClient.post(`${joinPath(API_SURVEYS, surveyId)}/start`),
    onSuccess: (_, surveyId) => {
      queryClient.invalidateQueries({
        queryKey: [...SURVEY_QUERY_KEY, surveyId],
      });
      queryClient.invalidateQueries({ queryKey: SURVEYS_QUERY_KEY });
    },
    onError: (error) => logRequestError(ErrorMessage.StartSurvey, error),
  });

  return { startSurvey, isStarting };
};
